<template>
  <div class="clear-both"></div>
  <div class="container">
    <div class="row">
      <div class="flex justify-between">
        <div class="w-1/2 p-4">
          <h2>Land Config</h2>
          <form @submit.prevent="submitLink" v-for="(link, os) in links" :key="'form-' + key">
            <div>
              <label :for="'input-' + key" class="form-label mt-5">{{os}}</label>
              <input :id="'input-' + key" type="text" v-model="links[os]" class="form-input"/>
            </div>
          </form>
          <loading-button :loading="loading" @click="submitLink" class="mt-5 btn-indigo ml-auto">
            Save Links
          </loading-button>
        </div>
        <div class="w-1/2 p-4">
          <pre>{{ jsonString }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {Head} from "@inertiajs/vue3";
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    LoadingButton,
  },
  props: {
    config: Object,
    guid: String,
    appName: String,
  },
  layout: Layout,
  data() {
    return {
      loading: false,
      guid: this.guid,
      links: this.config.links,
    };
  },
  methods: {
    submitLink() {
      this.loading = true;
      axios.post('/api/config/update-batch', {
        data: {
          links: this.links
        },
        guid: this.guid,
        appName: this.appName
      })
          .then(response => {
            this.loading = false;
            alert(`Update is queued`);
          })
          .catch(error => {
            console.error(`Error saving ${key}:`, error);
            alert(`Failed to save ${key}.`);
          });
    },
    serialize(obj) {
      const result = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] !== 'function') {
            result[key] = obj[key];
          }
        }
      }
      return result;
    }
  },
  mounted() {
    console.log(this.config);
  },
  computed: {
    jsonString() {
      const dataForJson = this.serialize(this.config);
      return JSON.stringify(dataForJson, null, 2);
    }
  }
}
</script>
